const tokenparser = require('./tokenparser');
const currency = require('./currency');
const { INTERNAL_PATH } = require('../constants');

const stripUndefined = (obj = {}) =>
  Object.entries(obj).reduce(
    (strippedObj, [key, val]) =>
      val === undefined
        ? strippedObj
        : {
            ...strippedObj,
            [key]: val,
          },
    {},
  );

const isInternal = (uri) =>
  uri?.startsWith(INTERNAL_PATH) || uri?.startsWith('/');

const displayNumber = (number) => (number < 10 ? `0${number}` : `${number}`);

const NOOP = () => {};

const convertToMap = (tabel, acumulator = {}, key = undefined) =>
  tabel.reduce((acc, value) => {
    acc[key ? value[key] : value._id || value.id] = value;
    return acc;
  }, acumulator);

module.exports = {
  tokenparser,
  currency,
  stripUndefined,
  isInternal,
  displayNumber,
  NOOP,
  convertToMap,
};
